import { createFileRoute } from '@tanstack/react-router';
import { packageStaticData } from '../../../package';

export const Route = createFileRoute('/_private-routes/package/$id/content/search')({
  staticData: packageStaticData
});
